module.exports = __webpack_public_path__ + "static/p2-8dbe49c3338dd31b88e871888da52213.jpg";